<template>
  <div class="logIn"></div>
</template>

<script>
import { mapState } from 'vuex'
import { login as webSDKLogin, logout as webSDKLogout } from '@/utils/websdk'

export default {
  name: 'OverseaLogin',

  computed: {
    ...mapState({
      showLoginPopup: state => state.LoginMask.MASK_ACTIVE,
    }),
  },

  watch: {
    showLoginPopup(val) {
      if (val) {
        this._loginTimer = setTimeout(() => {
          this.handleLogin()
        }, 200)
      } else {
        clearTimeout(this._loginTimer)
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this._loginTimer)
  },

  methods: {
    closePopup() {
      console.trace('close popup')
      this.$store.commit('LoginMask/SET_MASK_ACTIVE', false)
    },

    async handleLogin() {
      try {
        const res = await webSDKLogin('En', () => {})

        if (res.code === 0) {
          const loginRes = await this.axios.post('/user/login', {
            sdkuid: res.data.LOGIN_UID || '',
            token: res.data.LOGIN_TOKEN || '',
          })

          console.log('loginres', loginRes)
          localStorage.setItem('token', loginRes.token)
          await this.$store.dispatch('User/getUserInfo')
          this.closePopup()
        } else {
          alert(res.msg || res.message)
          webSDKLogout()
          this.closePopup()
        }
      } catch (err) {
        alert(err.data.message || err.message)
        webSDKLogout()
        this.closePopup()
      }
    },
  },

  // async handleLogin() {
  //   try {
  //     const res = await webSDKLogin('Kr', () => {})
  //     console.log('websdk res', res)

  //     const loginRes = await this.axios.post('/qa/login', {
  //       sdkuid: 'sdkuid-123',
  //       uid: 'uid-123',
  //       nickname: 'nickname-123',
  //     })

  //     console.log('login res', loginRes)
  //     if (loginRes && loginRes.token) {
  //       localStorage.setItem('token', loginRes.token)

  //       await this.$store.dispatch('User/getUserInfo')
  //       this.closePopup()
  //     }
  //   } catch (err) {
  //     alert('handleLogin err')
  //     alert(err.data.message || err.message)
  //     webSDKLogout()
  //     this.closePopup()
  //   }
  // },
  // },
}
</script>

<style lang="scss" scoped></style>
